import '@Shared/prototypes/prototypes';

import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { routes } from './app/app-routing.module';
import { sharedAppConfig } from 'projects/evolutics-shared-lib/src/lib/shared-app.config';

function setVariables() {
  if (environment.clientAppRoutes) environment.appRoutes = environment.clientAppRoutes;
  if (environment.clientMenus) environment.menus = environment.clientMenus;
  if (environment.clientExcludedMenus) environment.excludedMenus = environment.clientExcludedMenus;
  environment.isCorePortal = true;
  return environment;
}
bootstrapApplication(AppComponent, sharedAppConfig(routes, setVariables())).catch((err) =>
  console.error(err),
);
